export const TRANSIENT_OVERLAY = "[data-morph-keep-open]"
export const PRESERVED_STATE = "[data-morph-preserve]"
export const OWNED_CONTENT = "[data-morph-owns-content]"

export const BLOCKING_OVERLAY =
  `dialog[open], [role='dialog'], [role='menu'], [role='listbox'], ${TRANSIENT_OVERLAY}`

export const PRESERVED_ATTRIBUTES = ["hidden", "class", "data-open", "open", "style", "aria-expanded", "checked"]

function carriesAClientDrivenOpenAttribute(element) {
  return element.hasAttribute("data-open")
}

function isANativeDialogOnlyTheClientCanHaveOpened(element) {
  return element.tagName === "DIALOG" && element.open
}

function isMarkedPersistentClientState(element) {
  return element.matches(PRESERVED_STATE)
}

export function isVisible(element) {
  return element.checkVisibility
    ? element.checkVisibility({ opacityProperty: true, visibilityProperty: true })
    : element.offsetParent !== null
}

function livesInsideAnOverlayTheReaderCanSee(element) {
  const overlay = element.closest(BLOCKING_OVERLAY)
  return overlay !== null && isVisible(overlay)
}

export function preservesOwnState(element) {
  if (!(element instanceof HTMLElement)) return false

  return carriesAClientDrivenOpenAttribute(element) ||
    isANativeDialogOnlyTheClientCanHaveOpened(element) ||
    isMarkedPersistentClientState(element) ||
    livesInsideAnOverlayTheReaderCanSee(element)
}
